import { useMatch, useParams } from 'react-router-dom';

export default function useGetKitIdParam() {
  const { kitId } = useParams<{ kitId: string }>();

  const kitIdFromResultsMatch = useMatch<'kitId', string>(
    '/results/:kitId/*',
  )?.params;
  const kitIdFromActionPlanMatch = useMatch<'kitId', string>(
    '/action-plan/:kitId/*',
  )?.params;
  const kitIdFromReviewMatch = useMatch<'kitId', string>(
    '/review/:kitId',
  )?.params;

  return (
    kitId ??
    kitIdFromResultsMatch?.kitId ??
    kitIdFromActionPlanMatch?.kitId ??
    kitIdFromReviewMatch?.kitId
  );
}

/* OLD Phil's COMMENT */
// this is painful but I can't figure out a better way to do this
// basically, we want to get the kitId from the url, but usePage for page analytics
// happens outside of the route tree where that param exists, so we need to
// useMatch on specific routes if kitId isn't available from useParams
